import * as Context from "effect/Context";
export class Stage extends Context.Service()("Stage") {
}
//# sourceMappingURL=Stage.js.map